/**
 * 顧客の name / name_kana を保存前に整形する。
 *
 * - 前後の空白（半角・全角）をトリム
 * - 文字列内の全角スペース「　」を半角スペース「 」に置換
 *
 * 連続スペースの圧縮はしない（OCR 訂正用途で人為的な間隔を保持するため）。
 */
export function normalizeName(input: string): string {
  return input.replace(/　/g, " ").trim();
}
